var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.LIST.value
    }
  }, [_c('div', {
    staticClass: "tab-wrap"
  }, [_c('auction-program-search', _vm._b({
    attrs: {
      "onlySearch": ""
    }
  }, 'auction-program-search', {
    totalCount: _vm.totalCount
  }, false))], 1), _c('div', {
    staticClass: "tab-wrap"
  }, [_c('auction-category-select', _vm._b({
    attrs: {
      "value": _vm.category,
      "returnObject": "",
      "cols": "6",
      "sm": "4",
      "md": "3"
    },
    on: {
      "input": function input(category) {
        return _vm.$router.push("/private-sales/".concat(_vm.LIST.value, "/groups/").concat((category === null || category === void 0 ? void 0 : category.code) || 'all'));
      }
    }
  }, 'auction-category-select', {
    categories: _vm.categories
  }, false))], 1), _c('auction-work-list', {
    staticClass: "gallery-card-row",
    attrs: {
      "works": _vm.works
    }
  }), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    staticClass: "mt-8 mb-16",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _this.$route.query, {
            page: page
          })
        });
      }
    }
  })], 1), _c('v-fade-transition', {
    attrs: {
      "leave-absolute": ""
    }
  }, [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "color": "white",
      "light": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "indeterminate": "",
      "size": "100",
      "width": "5"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }